/* Shared by opendots2-pink-launch-* sections.
   Sticky nav / scroll-spy follows opendots2-pink-preheat.js.
   Consent gate follows sections/opendots2-jane-yeh-join.liquid.
   Modal + mobile carousel (idle until first expose, then 4s loop; manual action resets). */

(function () {
  var PAGE_CLASS = 'opendots2-pink-launch--tab-stuck';
  var READY = 'data-pink-launch-ready';
  var mqMobile = window.matchMedia('(max-width: 768px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DEFAULT_INTERVAL = 4000;
  var SWIPE_THRESHOLD = 40;

  function bindMq(mq, handler) {
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', handler);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(handler);
    }
  }

  function headerOffset() {
    var header = document.querySelector('.site-header');
    if (!header) return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  }

  function tabHeight(bar) {
    return bar ? bar.getBoundingClientRect().height : 0;
  }

  function inEditor() {
    return typeof Shopify !== 'undefined' && Shopify.designMode;
  }

  function scrollToTarget(selector, bar) {
    var el = document.querySelector(selector);
    if (!el) return;
    var offset = headerOffset() + tabHeight(bar);
    var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function initNav(nav) {
    var bar = nav.querySelector('[data-pink-launch-tabs]');
    var filler = nav.querySelector('[data-pink-launch-tabs-filler]');
    var tabs = Array.prototype.slice.call(nav.querySelectorAll('[data-pink-launch-tab]'));
    if (!bar || !tabs.length) return;

    var targets = tabs
      .map(function (tab) {
        var selector = tab.getAttribute('data-target');
        var el = selector ? document.querySelector(selector) : null;
        return el ? { tab: tab, el: el } : null;
      })
      .filter(Boolean);

    function setStuck(stuck) {
      var offset = headerOffset();
      document.body.classList.toggle(PAGE_CLASS, stuck);
      bar.classList.toggle('is-stuck', stuck);
      bar.style.top = stuck ? offset + 'px' : '';
      if (filler) {
        filler.style.height = stuck ? tabHeight(bar) + 'px' : '0px';
      }
    }

    function onScroll() {
      var offset = headerOffset();
      var navTop = nav.getBoundingClientRect().top;
      setStuck(navTop <= offset);

      if (!targets.length) return;
      var probe = window.pageYOffset + offset + tabHeight(bar) + 24;
      var active = targets[0];
      targets.forEach(function (item) {
        var top = item.el.getBoundingClientRect().top + window.pageYOffset;
        if (probe >= top) active = item;
      });
      targets.forEach(function (item) {
        var isActive = item === active;
        item.tab.classList.toggle('is-active', isActive);
        if (isActive) {
          item.tab.setAttribute('aria-current', 'true');
        } else {
          item.tab.removeAttribute('aria-current');
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        var selector = tab.getAttribute('data-target');
        if (!selector) return;
        event.preventDefault();
        scrollToTarget(selector, bar);
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  function initAnchorButtons(bar) {
    var buttons = document.querySelectorAll('[data-pink-launch-scroll]');
    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.getAttribute(READY) === 'true') return;
      btn.setAttribute(READY, 'true');
      btn.addEventListener('click', function (event) {
        var selector = btn.getAttribute('data-pink-launch-scroll');
        if (!selector) return;
        event.preventDefault();
        scrollToTarget(selector, bar);
      });
    });
  }

  function initModal(modal) {
    var closeEls = modal.querySelectorAll('[data-pink-launch-modal-close]');
    var lastFocus = null;

    function openModal() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('[data-pink-launch-modal-close]');
      if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
      modal.dispatchEvent(new CustomEvent('pink-launch:open', { bubbles: true }));
    }

    function closeModal() {
      if (!modal.classList.contains('is-open')) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modal.hidden = true;
      document.body.style.overflow = '';
      modal.dispatchEvent(new CustomEvent('pink-launch:close', { bubbles: true }));
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    modal.pinkLaunchOpen = openModal;
    modal.pinkLaunchClose = closeModal;

    Array.prototype.forEach.call(closeEls, function (el) {
      el.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
  }

  function initModalOpeners() {
    var openers = document.querySelectorAll('[data-pink-launch-modal-open]');
    Array.prototype.forEach.call(openers, function (btn) {
      if (btn.getAttribute(READY) === 'true') return;
      btn.setAttribute(READY, 'true');
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var selector = btn.getAttribute('data-pink-launch-modal-open');
        var modal = selector
          ? document.querySelector(selector)
          : btn.closest('.shopify-section')
            ? btn.closest('.shopify-section').querySelector('[data-pink-launch-modal]')
            : null;
        if (modal && typeof modal.pinkLaunchOpen === 'function') modal.pinkLaunchOpen();
      });
    });
  }

  function initEscapeOnce() {
    if (document.body.getAttribute('data-pink-launch-esc') === 'true') return;
    document.body.setAttribute('data-pink-launch-esc', 'true');
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openModal = document.querySelector('[data-pink-launch-modal].is-open');
      if (openModal && typeof openModal.pinkLaunchClose === 'function') {
        openModal.pinkLaunchClose();
      }
    });
  }

  function initConsent(root) {
    var check = root.querySelector('[data-pink-launch-consent-check]');
    var btn = root.querySelector('[data-pink-launch-consent-btn]');
    if (!check || !btn) return;

    var label = root.classList.contains('opendots2-pink-launch-consent')
      ? root
      : root.querySelector('.opendots2-pink-launch-consent') || root;

    function sync() {
      var enabled = !!check.checked;
      btn.classList.toggle('is-disabled', !enabled);
      btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      if (btn.tagName === 'BUTTON') btn.disabled = !enabled;
      if (enabled) label.classList.remove('is-shaking');
    }

    function shake() {
      label.classList.remove('is-shaking');
      void label.offsetWidth;
      label.classList.add('is-shaking');
    }

    check.addEventListener('change', sync);
    sync();

    btn.addEventListener('click', function (event) {
      if (check.checked) return;
      event.preventDefault();
      shake();
      if (typeof check.focus === 'function') check.focus();
    });
  }

  function initCarousel(root) {
    var viewport = root.querySelector('[data-pink-launch-carousel-viewport]');
    var track = root.querySelector('[data-pink-launch-carousel-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pink-launch-carousel-slide]'));
    var prev = root.querySelector('[data-pink-launch-carousel-prev]');
    var next = root.querySelector('[data-pink-launch-carousel-next]');
    if (!viewport || !track || slides.length < 2) return;

    var intervalMs = parseInt(root.getAttribute('data-pink-launch-interval') || '', 10);
    if (!intervalMs || intervalMs < 1) intervalMs = DEFAULT_INTERVAL;
    var loop = root.getAttribute('data-pink-launch-loop') !== 'false';
    var mobileOnly = root.hasAttribute('data-pink-launch-mobile-only');
    var modal = root.closest('[data-pink-launch-modal]');
    var index = 0;
    var timer = null;
    var exposed = false;
    var inView = false;
    var touchStartX = 0;
    var touchStartY = 0;

    function isMobile() {
      return !mobileOnly || mqMobile.matches;
    }

    function canAutoplay() {
      return isMobile() && !reduceMotion.matches && !inEditor() && !document.hidden && slides.length > 1;
    }

    function update() {
      var enabled = isMobile();
      var width = viewport.clientWidth;
      track.style.transform = enabled && width ? 'translate3d(' + -(index * width) + 'px,0,0)' : '';
      Array.prototype.forEach.call(slides, function (slide, i) {
        slide.setAttribute('aria-hidden', enabled && i !== index ? 'true' : 'false');
      });
      if (prev) prev.disabled = !enabled || (!loop && index <= 0);
      if (next) next.disabled = !enabled || (!loop && index >= slides.length - 1);
    }

    function goTo(nextIndex) {
      if (!slides.length) return;
      if (loop) {
        index = ((nextIndex % slides.length) + slides.length) % slides.length;
      } else {
        index = Math.max(0, Math.min(slides.length - 1, nextIndex));
      }
      update();
    }

    function stopTimer() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function startTimer() {
      stopTimer();
      if (!canAutoplay() || !exposed || !inView) return;
      timer = window.setTimeout(function () {
        timer = null;
        goTo(index + 1);
        startTimer();
      }, intervalMs);
    }

    function setInView(visible) {
      if (inView === visible) return;
      inView = visible;
      if (visible) {
        exposed = true;
        startTimer();
      } else {
        stopTimer();
      }
    }

    function onManual(delta) {
      if (!isMobile()) return;
      goTo(index + delta);
      inView = true;
      exposed = true;
      startTimer();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        onManual(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        onManual(1);
      });
    }

    viewport.addEventListener(
      'touchstart',
      function (event) {
        if (!event.changedTouches || !event.changedTouches.length) return;
        touchStartX = event.changedTouches[0].clientX;
        touchStartY = event.changedTouches[0].clientY;
      },
      { passive: true }
    );
    viewport.addEventListener(
      'touchend',
      function (event) {
        if (!isMobile() || !event.changedTouches || !event.changedTouches.length) return;
        var dx = event.changedTouches[0].clientX - touchStartX;
        var dy = event.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) <= Math.abs(dy)) return;
        onManual(dx < 0 ? 1 : -1);
      },
      { passive: true }
    );

    function onMqChange() {
      if (!isMobile()) {
        stopTimer();
        index = 0;
        update();
        return;
      }
      update();
      if (inView) {
        exposed = true;
        startTimer();
      }
    }

    bindMq(mqMobile, onMqChange);
    bindMq(reduceMotion, onMqChange);

    window.addEventListener('resize', function () {
      if (isMobile()) update();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopTimer();
      } else if (exposed && inView) {
        startTimer();
      }
    });

    function modalIsOpen() {
      return modal && modal.classList.contains('is-open');
    }

    if (modal) {
      modal.addEventListener('pink-launch:open', function () {
        index = 0;
        inView = false;
        update();
        setInView(true);
        window.requestAnimationFrame(function () {
          update();
        });
      });
      modal.addEventListener('pink-launch:close', function () {
        setInView(false);
        exposed = false;
        index = 0;
        update();
      });
      if (modalIsOpen()) setInView(true);
    } else if (typeof IntersectionObserver === 'function') {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var mostlyVisible = entry.intersectionRatio >= 0.6;
            if (!isMobile()) {
              inView = mostlyVisible;
              stopTimer();
              return;
            }
            setInView(mostlyVisible);
          });
        },
        { threshold: [0, 0.6, 1] }
      );
      observer.observe(viewport);
    } else {
      function checkFallback() {
        if (!isMobile()) {
          inView = false;
          stopTimer();
          return;
        }
        var rect = viewport.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var visible = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
        setInView(rect.height > 0 && visible >= rect.height * 0.6);
      }
      window.addEventListener('scroll', checkFallback, { passive: true });
      window.addEventListener('resize', checkFallback);
      checkFallback();
    }

    update();
  }

  function initProductCard(card) {
    var img = card.querySelector('[data-pink-launch-product-image]');
    var price = card.querySelector('[data-pink-launch-product-price]');
    var buy = card.querySelector('[data-pink-launch-product-buy]');
    var swatches = card.querySelectorAll('[data-pink-launch-swatch]');
    if (!swatches.length) return;

    Array.prototype.forEach.call(swatches, function (btn) {
      btn.addEventListener('click', function () {
        Array.prototype.forEach.call(swatches, function (other) {
          var on = other === btn;
          other.classList.toggle('is-active', on);
          other.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var imageUrl = btn.getAttribute('data-image');
        if (img && imageUrl) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = imageUrl;
        }
        var nextPrice = btn.getAttribute('data-price');
        if (price && nextPrice) price.textContent = nextPrice;
        var nextUrl = btn.getAttribute('data-variant-url');
        if (buy && nextUrl) buy.setAttribute('href', nextUrl);
        if (buy) {
          ['sku', 'name', 'price', 'discount', 'color'].forEach(function (key) {
            var val = btn.getAttribute('data-ga-' + key);
            if (val != null) card.setAttribute('data-ga-' + key, val);
          });
        }
      });
    });
  }

  var LIST_ID = 'opendots2_pink_onsale';

  function pushGa4(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: params || {}
    });
  }

  function skuCategory(sku) {
    var match = String(sku || '').match(/^[A-Za-z]+\d+/);
    return match ? match[0] : '';
  }

  function parseMoney(value) {
    var n = parseFloat(String(value || '0').replace(/,/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function buildProductItem(source, listName) {
    var sku = source.getAttribute('data-ga-sku') || '';
    return {
      item_id: sku,
      item_name: source.getAttribute('data-ga-name') || '',
      discount: parseMoney(source.getAttribute('data-ga-discount')),
      index: 1,
      item_list_id: LIST_ID,
      item_list_name: listName || LIST_ID,
      item_category: skuCategory(sku),
      item_category2: 'Standard',
      item_category3: source.getAttribute('data-ga-color') || '',
      item_variant: 'Truewireless',
      item_brand: 'SHOKZ',
      price: parseMoney(source.getAttribute('data-ga-price')),
      quantity: 1,
      currency: 'THB'
    };
  }

  function activeProductSource(card) {
    return card.querySelector('[data-pink-launch-swatch].is-active') || card;
  }

  function observeModuleBottom(el, onHit) {
    if (!el || el.getAttribute('data-pink-launch-impression-ready') === 'true') return;
    el.setAttribute('data-pink-launch-impression-ready', 'true');
    var fired = false;
    function check() {
      if (fired) return;
      var rect = el.getBoundingClientRect();
      if (rect.bottom <= window.innerHeight) {
        fired = true;
        window.removeEventListener('scroll', check);
        window.removeEventListener('resize', check);
        onHit();
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  function initProductGa4(card) {
    observeModuleBottom(card, function () {
      var item = buildProductItem(activeProductSource(card), LIST_ID);
      pushGa4('view_item_list', {
        item_list_id: LIST_ID,
        item_list_name: LIST_ID,
        currency: 'THB',
        items: [item]
      });
    });

    var buy = card.querySelector('[data-pink-launch-product-buy]');
    if (buy && buy.getAttribute('data-pink-launch-ga-bound') !== 'true') {
      buy.setAttribute('data-pink-launch-ga-bound', 'true');
      buy.addEventListener('click', function () {
        var item = buildProductItem(activeProductSource(card), 'Navigation _ ' + LIST_ID);
        pushGa4('select_item', {
          item_list_id: LIST_ID,
          item_list_name: LIST_ID,
          button_name: (buy.textContent || '').trim(),
          items: [item]
        });
      });
    }

    var more = card.querySelector('[data-pink-launch-product-more]');
    if (more && more.getAttribute('data-pink-launch-ga-bound') !== 'true') {
      more.setAttribute('data-pink-launch-ga-bound', 'true');
      more.addEventListener('click', function () {
        var nameEl = card.querySelector('.opendots2-pink-launch-join__product-name');
        pushGa4('select_content', {
          content_type: LIST_ID,
          content_name: nameEl ? (nameEl.textContent || '').trim() : '',
          button_name: (more.textContent || '').trim()
        });
      });
    }
  }

  function initSignupGa4(root) {
    observeModuleBottom(root, function () {
      pushGa4('module_impression', { module: 'event_register' });
    });
    var btn = root.querySelector('[data-pink-launch-consent-btn]');
    var check = root.querySelector('[data-pink-launch-consent-check]');
    if (!btn || btn.getAttribute('data-pink-launch-ga-bound') === 'true') return;
    btn.setAttribute('data-pink-launch-ga-bound', 'true');
    btn.addEventListener('click', function () {
      if (check && !check.checked) return;
      pushGa4('select_content', {
        content_type: 'event_register',
        content_name: root.getAttribute('data-ga-content-name') || '',
        button_name: 'join_now'
      });
    });
  }

  function init() {
    var nav = document.querySelector('[data-pink-launch-nav]');
    var bar = nav ? nav.querySelector('[data-pink-launch-tabs]') : null;
    if (nav && nav.getAttribute(READY) !== 'true') {
      nav.setAttribute(READY, 'true');
      initNav(nav);
    }
    initAnchorButtons(bar);

    var modals = document.querySelectorAll('[data-pink-launch-modal]');
    Array.prototype.forEach.call(modals, function (modal) {
      if (modal.getAttribute(READY) === 'true') return;
      modal.setAttribute(READY, 'true');
      initModal(modal);
    });
    initModalOpeners();
    initEscapeOnce();

    var consents = document.querySelectorAll('[data-pink-launch-consent]');
    Array.prototype.forEach.call(consents, function (root) {
      if (root.getAttribute(READY) === 'true') return;
      root.setAttribute(READY, 'true');
      initConsent(root);
    });

    var carousels = document.querySelectorAll('[data-pink-launch-carousel]');
    Array.prototype.forEach.call(carousels, function (root) {
      if (root.getAttribute(READY) === 'true') return;
      root.setAttribute(READY, 'true');
      initCarousel(root);
    });

    var productCards = document.querySelectorAll('[data-pink-launch-product]');
    Array.prototype.forEach.call(productCards, function (card) {
      if (card.getAttribute(READY) !== 'true') {
        card.setAttribute(READY, 'true');
        initProductCard(card);
      }
      initProductGa4(card);
    });

    var signups = document.querySelectorAll('[data-pink-launch-signup]');
    Array.prototype.forEach.call(signups, function (root) {
      initSignupGa4(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
